import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/shared/store/store';
import { Layout, ChevronRight, Repeat } from 'lucide-react';
import { cn } from '@/shared/utils/cn';

interface WorkspaceSelectorCardProps {
    user: any;
    collapsed?: boolean;
    onOpenSelector: () => void;
}

export const WorkspaceSelectorCard: React.FC<WorkspaceSelectorCardProps> = ({
    user,
    collapsed,
    onOpenSelector
}) => {
    const { isImpersonating, targetUser } = useSelector((state: RootState) => state.impersonation);

    // Consideramos SUPER_ADMIN si el rol coincide (normalizamos a mayúsculas por seguridad)
    const role = user?.role?.toString().toUpperCase();
    const isSuperAdmin = role === 'SUPER_ADMIN' || role === 'ADMIN';

    // Solo mostrar si es SUPER_ADMIN o si ya estamos impersonando
    if (!isSuperAdmin && !isImpersonating) return null;

    const displayName = isImpersonating
        ? (targetUser?.firstName || targetUser?.name || 'Usuario')
        : (user?.firstName || user?.name || 'Super Admin');

    return (
        <div className="px-4 py-3">
            <button
                type="button"
                onClick={onOpenSelector}
                className={cn(
                    "w-full flex items-center transition-all duration-200 rounded-lg",
                    "bg-primary-600 text-white cursor-pointer",
                    collapsed ? "p-2 justify-center" : "p-3 space-x-3 text-left hover:bg-primary-700 active:scale-[0.98]"
                )}
            >
                <div className={cn(
                    "flex-shrink-0 rounded-md flex items-center justify-center bg-white/20",
                    collapsed ? "h-8 w-8" : "h-10 w-10"
                )}>
                    {isImpersonating ? (
                        <Repeat className="h-5 w-5 text-white" />
                    ) : (
                        <Layout className="h-5 w-5 text-white" />
                    )}
                </div>

                {!collapsed && (
                    <div className="flex-1 min-w-0">
                        <p className="text-[10px] font-bold uppercase tracking-wider text-primary-100 leading-none mb-1">
                            {isImpersonating ? 'Espacio de Trabajo' : 'Vista Super Admin'}
                        </p>
                        <p className="text-sm font-semibold truncate text-white">
                            {displayName}
                        </p>
                    </div>
                )}

                {!collapsed && (
                    <ChevronRight className="h-4 w-4 text-primary-200" />
                )}
            </button>
        </div>
    );
};
